import { createSelector, Selector } from 'reselect';

import { RootState } from '../';
import { Category, Categories, SubCategories } from './interfaces';

export const categoriesSelector: Selector<RootState, Categories> = ({ categories }) => {
  return categories.categories || {};
};

export const subCategoriesSelector: Selector<RootState, SubCategories> = ({ categories }) => {
  return categories.subCategories || {};
};

export const categoryIdsSelector: Selector<RootState, string[]> = ({ categories }) => {
  return categories.categoryIds || [];
};

export const getCategories = () => {
  return createSelector<RootState, Categories, string[], Category[]>(
    [categoriesSelector, categoryIdsSelector],
    (categories, categoryIds) => {
      const _items: Category[] = [];

      categoryIds.map((id) => {
        const category = categories[id];
        if (category) _items.push(category);
      });

      return _items;
    },
  );
};

export const getSubCategories = () => {
  return createSelector<RootState, SubCategories, SubCategories>(
    [subCategoriesSelector],
    (subCategories) => {
      return subCategories;
    },
  );
};
